"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactPhoneInput = _interopRequireDefault(require("react-phone-input-2"));
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
var TelephoneInput = function TelephoneInput(_ref) {
  var label = _ref.label,
    name = _ref.name,
    labelHidden = _ref.labelHidden,
    onChange = _ref.onChange,
    id = _ref.id,
    alert = _ref.alert,
    required = _ref.required,
    defaultCountry = _ref.defaultCountry,
    value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-input margin-bottom-sm"
  }, !labelHidden && /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label margin-bottom-sm",
    htmlFor: id || label.replace(/\s+/g, '-').toLowerCase(),
    "data-section": "form-label"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-relative"
  }, /*#__PURE__*/_react["default"].createElement(_reactPhoneInput["default"], {
    country: defaultCountry,
    value: value,
    onChange: onChange,
    inputProps: {
      name: name,
      required: required
    }
  })), alert && /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    className: "margin-top-sm",
    show: alert.showNotification,
    text: alert.notificationMessage,
    type: alert.notificationType,
    onClose: alert.onClose
  }));
};
TelephoneInput.propTypes = {
  label: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  labelHidden: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  alert: _propTypes["default"].object,
  defaultCountry: _propTypes["default"].string,
  value: _propTypes["default"].string
};
TelephoneInput.defaultProps = {
  required: false,
  defaultCountry: 'gb'
};
var _default = exports["default"] = TelephoneInput;